import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
    getEmployeePermissions,
    getFirstAllowedRoute,
    isUrsSession,
    isSipEmployee,
} from '../helpers/employeePermissions';

export default function RequirePermission({ children, permission }) {
    const employeeData = useSelector((state) => state.users.employeeData);

    if (!permission) return children;

    if (isUrsSession()) return children;
    if (!isSipEmployee(employeeData)) return children;

    const permissions = getEmployeePermissions(employeeData);
    const allowed = Array.isArray(permission)
        ? permission.some((p) => permissions.includes(p))
        : permissions.includes(permission);

    if (!allowed) {
        return <Navigate to={getFirstAllowedRoute(employeeData)} replace />;
    }
    return children;
}
